export default [
    {
        path: '/hr/permits',
        name: 'permits',
        props: true,
        component: () => import('@/views/hr/permits/index.vue'),
        meta: {
            pageTitle: 'Permits',
            breadcrumb: [
                {
                text: 'Permits',
                active: true,
                },
            ],
        },
    },
    {
        path: '/hr/permits/:id',
        name: 'detail-permits',
        props: true,
        component: () => import('@/views/hr/permits/detail.vue'),
        meta: {
            pageTitle: 'Detail Permit',
            breadcrumb: [
                {
                text: 'Permits',
                to: { name: 'permits' },
                },
                {
                text: 'Detail Permit',
                active: true,
                },
            ],
        },
    },
]